import React, { useEffect, useState, useRef } from "react";
import "./dailybestsells.css";
import img11 from "../../assets/images/best_sells_bg2.jpg";
import Button from "@mui/material/Button";  
import { Link } from "react-router-dom";
 import DailyBestSellsSlider from "./DailyBestSellsSlider";
import "../../components/popularProducts/popularproducts.css";

const DailyBestSells = () => {
 
  const [time, setTime] = useState({
    days: 7,
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  });

  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setTime((prevTime) => {
        let { days, hours, minutes, seconds, milliseconds } = prevTime;

        if (
          days === 0 &&
          hours === 0 &&
          minutes === 0 &&
          seconds === 0 &&
          milliseconds === 0
        ) {
          clearInterval(intervalRef.current);
          return prevTime;
        }

        if (milliseconds === 0) {
          milliseconds = 99;
          if (seconds === 0) {
            seconds = 59;
            if (minutes === 0) {
              minutes = 59;
              if (hours === 0) {
                hours = 23;
                days -= 1;
              } else {
                hours -= 1;
              }
            } else {
              minutes -= 1;
            }
          } else {
            seconds -= 1;
          }
        } else {
          milliseconds -= 1;
        }

        return { days, hours, minutes, seconds, milliseconds };
      });
    }, 10);

    return () => clearInterval(intervalRef.current);
  }, []);

  const { days, hours, minutes, seconds, milliseconds } = time;

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="heading_common mt_30">
              <h3>Daily Best Sells</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4">
            <div className="best_sells_box relative pt_15">
              <div className="best_sells_box_in relative">
                <img src={img11} alt="Best Sells" className="img-fluid rounded" />
              </div>
              <div className="best_sells_text">
                <div className="best_sells_text_in">
                  <h4>Deals Of the Day</h4>
                  <h5 className="common_color">
                    Save up to 50% off on your first order
                  </h5>
                  <div className="best_sells_timer">
                    {days === 0 &&
                    hours === 0 &&
                    minutes === 0 &&
                    seconds === 0 &&
                    milliseconds === 0 ? (
                      <h1>Busted!</h1>
                    ) : (
                      <div className="time-box-wrapper">
                        <div className="single-box">
                          <h6>{days} D</h6>
                          <span>:</span>
                        </div>
                        <div className="single-box">
                          <h6>{hours} H</h6>
                          <span>:</span>
                         </div>
                        <div className="single-box">
                          <h6>{minutes} M</h6>
                          <span>:</span>
                         </div>
                        <div className="single-box">
                          <h6>{seconds} S</h6>
                          <span>:</span>
                         </div>
                        <div className="single-box">
                          <h6>{milliseconds} MS</h6>
                          </div>
                      </div>
                    )}
                  </div>
                  <div className="common_btn_box btn_best_sells">
                     <Button ><Link to="searchproductlist" class="common_btn_shop "> Shop Now</Link></Button>
                 </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8">
             <DailyBestSellsSlider />
           </div>
        </div>
      </div>
    </>
  );
};

export default DailyBestSells;
